import applyTreeChanges from './applyTreeChanges';
import collectTreeChanges from './collectTreeChanges';

const updateTreeState = (
  prevTreeState,
  modelsOrChanges,
  { adapter, plugins },
  options,
) =>
  applyTreeChanges(
    prevTreeState,
    collectTreeChanges(prevTreeState, modelsOrChanges, { adapter }, options),
    { adapter, plugins },
    options,
  );

export default updateTreeState;
